module.exports = __webpack_public_path__ + "img/png.1f100450.svg";